export default __webpack_public_path__ + "static/media/hand-with-chocolate.349f8f95.png";